var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.$AuthService.hasPermissionForActiveVenue(
      'vp.vp.booking.createbookings'
    )
  )?_c('vs-popup',{staticClass:"add-booking-popup",attrs:{"title":_vm.getTitle(),"active":_vm.showThisPopup},on:{"update:active":function($event){_vm.showThisPopup=$event},"close":_vm.handleClose}},[_c('editing-booking',{ref:"editingBookingComponent",attrs:{"venue-details":_vm.venueDetails,"editing-mode":_vm.EDITING_MODE.Create},on:{"booking-saved":_vm.handleBookingSaved}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }